import React from 'react';
import './index.scss';
import '../../assets/fonts.css';

import theme_library_icon from '../../assets/Theme-Library.png';
import picture_library_icon from '../../assets/Picture-Library.png';
import diagram_library_icon from '../../assets/Diagram-Library.png';
import smart_diagram_icon from '../../assets/Smart-Diagram.png';
import color_library_icon from '../../assets/Color-Library.png';
import vector_library_icon from '../../assets/Vector-Library.png';
import one_click_optimization_icon from '../../assets/One-Click-Optimization.png';
import design_layout_icon from '../../assets/Design-Layout.png';
import icon_library_icon from '../../assets/Icon-Library.png';
import join_image_icon from '../../assets/Join-Image.png';

import top_arrow_icon from '../../assets/toparrow.png';
import bottom_arrow_icon from '../../assets/bottomarrow.png';

import resource_icon from '../../assets/resources.jpg';
import time_icon from '../../assets/times.jpg';
import user_icon from '../../assets/users.jpg';

import successIcon from '../../assets/v1.png';

import { Dialog } from '../../components/Dialog';
import { Header } from './components/Header';
import { HomeBanner } from './components/HomeBanner';
import { AmazingFeatures } from './components/AmazingFeatures';
import { IFeature } from './components/FeatureBlock';
import { Services, IService } from './components/Services';
import { Footer } from './components/Footer';
import urlparser from 'urlparser';
import { Helmet } from 'react-helmet';

import * as api from '../../services/api';
import { IInviteProps, ITrialRes } from '../InvitePage';
import ReactGA from 'react-ga';

const features: Array<Array<IFeature>> = [
  [
    {
      title: 'Theme Library',
      icon: theme_library_icon,
      content:
        'It aggregates hundreds of templates, each applies exclusive fonts, color schemes, cover, back cover and layout.'
    },
    {
      title: 'Picture Library',
      icon: picture_library_icon,
      content:
        '7k+ free CC0-Licensed pictures. Easily search whatever picture you want by category, keyword and more.'
    }
  ],
  [
    {
      title: 'Diagram Library',
      icon: diagram_library_icon,
      content:
        '4000+ well-designed diagrams are optional, each automatically adopts to the color and layout rules of current slides.'
    },
    {
      title: 'Smart Diagram',
      icon: smart_diagram_icon,
      content:
        '1000+ diagrams are fully editable. Customize your own diagram by adjusting the value and replacing color and icon.'
    }
  ],
  [
    {
      title: 'Color Library',
      icon: color_library_icon,
      content:
        '100+ well-matched professional color schemes are available. Just click to apply it to all/selected slides.'
    },
    {
      title: 'Vector Library',
      icon: vector_library_icon,
      content:
        '2k+ high-quality vectors are for your option. Made by professional designers, all the vectors are resizable.'
    }
  ],
  [
    {
      title: 'One-Click Optimization',
      icon: one_click_optimization_icon,
      content:
        'By one click, uniform the fonts, paragraphs, colors, layouts and styles of all slides'
    },
    {
      title: 'Design Layout',
      icon: design_layout_icon,
      content:
        'Super-handy design tools help you handle slides and create thousands of stunning design layouts with ease.'
    }
  ],
  [
    {
      title: 'Icon Library',
      icon: icon_library_icon,
      content: '100k+ icons are free to use. Just click to insert & replace.'
    },
    {
      title: 'Join Image',
      icon: join_image_icon,
      content:
        'Splice slides according to your needs and export them as an image in a snap.'
    }
  ]
];

const services: Array<IService> = [
  {
    title: '200k+ resources',
    img: resource_icon,
    content:
      'Find whatever you need in 200k+ built-in professional and up-to-date PowerPoint templates, diagrams, pictures, icons and other resources.'
  },
  {
    title: 'Saving 90% of design time',
    img: time_icon,
    content:
      'Boasting a lot of one-click features and handy design tools, iSlide can save you up to 90% time in formatting when making PowerPoint slides.'
  },
  {
    title: '2M+ users',
    img: user_icon,
    content:
      'The common choice of 2M+ users worldwide. Join us to make excellent PowerPoint presentation to convince, influence and impress your audience.'
  }
];


interface IState {
  arrowIcon: string;
  features: Array<any>;
  services: Array<any>;
  errMsg: string;
  showErr: boolean;
  jwt: string;
  time: string;
  showDialog: boolean;
  title: string;
  inviterId: string;
  trailId:string;
  state:string;
}
interface IProps {
  logo: string,
  inviterId: string;
  trailId: string;
  state:string;
}
export class CampaignPage extends React.Component<IProps, IState> {
  public readonly state: Readonly<IState> = {
    arrowIcon: bottom_arrow_icon,
    features: features.slice(0, 2),
    services: services,
    errMsg: '',
    showErr: false,
    showDialog: false,
    jwt: '',
    time: '',
    title: 'iSlide - Premium Membership Giveaway',
    inviterId:'',
    trailId:'',
    state:''
  };

  componentDidMount() {
    this.setState(
      {
        trailId:this.props.trailId,
        inviterId:this.props.inviterId
      });
  }
  handleArrow() {
    if (this.state.features.length === 2) {
      this.setState({
        arrowIcon: top_arrow_icon,
        features: features
      });
    } else {
      this.setState({
        arrowIcon: bottom_arrow_icon,
        features: features.slice(0, 2)
      });
    }
  }

  async handleSubmit(email: string) {
    if (!email) {
      return this.setState({
        errMsg: 'email is required',
        showErr: true
      });
    }
    let result: ITrialRes = await api.register(email,this.state.trailId,this.state.state,this.state.inviterId,'en');
    if (result.error) {
      return this.setState({
        errMsg: result.error,
        showErr: true
      });
    }
    if (result.body) {
      this.setState({
        errMsg: ''
      });
      ReactGA.pageview(window.location.pathname+`/${result.body.days}days/email/success`);
      this.setState({
        time: `${result.body.days}`,
        showDialog: true
      });
    }
  }

  render() {
    return (
      <div className="campaign-page">
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        <Header onSubmit={this.handleSubmit.bind(this)} />
        <HomeBanner
          onSubmit={this.handleSubmit.bind(this)}
          error={this.state.errMsg}
        />
        <AmazingFeatures
          features={this.state.features}
          arrowIcon={this.state.arrowIcon}
          handleArrow={this.handleArrow.bind(this)}
        />
        <Services services={this.state.services} />
        <Footer />
        <Dialog
          visible={this.state.showDialog}
          onClose={() => {
            this.setState({
              showDialog: false
            });
          }}
        >
          <div className="dialog-success">
            <img src={successIcon} alt="success" />
            <p className="message">Account Activated</p>
            <section className="footer">
              <p className="remark">
                Your experience membership duration is {this.state.time} days, please login in time.
              </p>
              <p className="remark" style={{ marginTop: '0.2rem' }}>
                Please check your email
              </p>
              <p className="remark" style={{ marginBottom: '0.4rem' }}>
                (May be mistaken for junk mail)
              </p>
            </section>
          </div>
        </Dialog>
      </div>
    );
  }
}
